<template>
 <v-container class="mt-4">
    <span v-if="successBestellungPzr">
      <h3 class="text-green">Wir werden Ihnen auch die WaizmannTabelle PZR-Flatrate kostenlos zusenden.</h3>
      </span>
    <span v-if="!successBestellungPzr">
    <span v-if="successBestellung">
    <h3 class="text-green">Wir werden Ihnen den neuen WaizmannTabellen in Kürze kostenlos zusenden.</h3>
  </span>
  <span v-else>
    <h3 class="text-orange">Wir bearbeiten gerade Ihre Anforderung</h3>
  </span>
</span>
  <v-row class="my-4"  v-if="successBestellung && !successBestellungPzr">
     
      <v-col  cols="8">
        <h2>
         Sollen wir Ihnen auch die neue<br> WaizmannTabelle PZR-Flatrate kostenlos zusenden?
        </h2>
        T0P 10 der PZR-Flatrate Tarife. Diese Tarife leisten sowohl für
        Zahnersatz & Zahnerhalt als auch in unbegrenzter Höhe und Anzahl für
        die professionelle Zahnreinigung. Auch für mehr als 2 PZR-Behandlungen
        pro Jahr.<br>
        <v-btn color="primary" class="mt-4" @click="sendPzr()">Ja, bitte senden Sie mir die WaizmannTabelle PZR-Flatrate kostenlos zu</v-btn>
      </v-col>
      <v-col cols="4" v-if="baseStore.isDesktop">
        <img
          :src="require('@/assets/bestellung/auftstellerPremiumPzr.png')"
          style="width: 280px; float: left"
        />
      </v-col>
    </v-row>
  </v-container> 
</template>

<script setup>
import { inject, onMounted,ref,reactive } from 'vue'
import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router'

const baseCalls = inject('baseCalls')
const loaderStore = inject('loaderStore');
const userStore = inject('userStore');
const successStore = inject('successStore');
const errorStore = inject('errorStore');
const { userData } = storeToRefs(userStore)
const successBestellung = ref(false);
const successBestellungPzr = ref(false);
const baseStore = inject('baseStore')

const bestellung = reactive({
    bestell_status: 0,
    bestell_comment: "",
    bestell_produkt_text: "",
    bestell_kategorie: 0,
    action: 'neueBestellung',

  });
const route = useRoute();
async function startLogin() {
  const data = { action: 'startlogin',token: route.params.token }
  //console.log(data);
 
  loaderStore.setLoader(true, "Bitte warten, Sie werden eingeloggt...");
  try {
    const response = await baseCalls.userPost(data);
    if (response.data.user ) {
      startNeueBestellung('onlinePremiumAufsteller');
      console.log('Benutzerdaten geladen:', response.data);
      userStore.setUser(response.data.user )

      loaderStore.setLoader(false);
      
    }  else {
      errorStore.setError( true, 'Fehler beim Laden der Benutzerdaten');
    }
  } catch (err) {
   
    errorStore.setError(true, 'Fehler beim Laden der Benutzerdaten');
    console.error('API-Fehler:', err);
  } finally {

    loaderStore.setLoader(false);
  }
}
async function startNeueBestellung(product)
{
  bestellung.bestell_produkt_text = product;
  loaderStore.setLoader(true)
  const response = await baseCalls.bestellungPost(bestellung)
  if (response.data.success) {
    if (product == 'onlinePremiumAufsteller') {
      successBestellung.value = true;
      successStore.setSuccess(true,'Ihre Bestellung wurde erfolgreich gespeichert','Ihre Bestellung wird in Kürze bearbeitet.')
      setTimeout(() => {
        successStore.setSuccess(false,'','')
      }, 1000);
    } 
    if (product == 'onlinePremiumAufstellerPzr') {
      successBestellungPzr.value = true;
      successStore.setSuccess(true,'Ihre Bestellung wurde erfolgreich gespeichert','Ihre Bestellung wird in Kürze bearbeitet.')
    }
    loaderStore.setLoader(false)
    
    bestellung.bestell_produkt_text = '';
    bestellung.bestell_comment = '';
   
  } else {
   
    errorStore.setError('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.')
  }
}
onMounted(() => {
  if (!userData.value && route.params.token != null) {
    startLogin();
  }
});

  //import { reactive, ref } from "vue";
</script>
